import { useContext, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
  FormControlLabel,
  RadioGroup,
  Box,
  Typography,
} from '@material-ui/core';
import { MAIN_CONTAINER_ID } from '../../constants';
import { DeviceContext } from '../../contexts';
import { ButtonTitleWithLoading } from '../ButtonTitleWithLoading';
import { AppRoundedRadio } from '../inputs/AppRadio';

export const ChatLimitMessageSendersDialog = ({
  open,
  handleClose,
  loading,
  confirmFunction,
  readOnly,
  setReadOnly,
}: {
  open: boolean;
  handleClose: () => void;
  loading: boolean;
  confirmFunction: () => void;
  readOnly: boolean;
  setReadOnly: (readOnly: boolean) => void;
}) => {
  const { isMobile } = useContext(DeviceContext);
  const [value, setValue] = useState<'all' | 'only_admins'>(readOnly ? 'only_admins' : 'all');

  const handleChange = (value: 'all' | 'only_admins') => {
    if (!value) {
      return;
    }
    setValue(value);
    setReadOnly(value === 'only_admins');
  };

  return (
    <Dialog
      container={document.getElementById(MAIN_CONTAINER_ID)}
      fullScreen={isMobile}
      maxWidth="sm"
      fullWidth
      open={open}
      onClose={handleClose}
    >
      <DialogTitle>Limit message senders</DialogTitle>

      <DialogContent>
        <DialogContentText>
          All the group chat’s members may read the messages, but you can choose who can send them.
        </DialogContentText>

        <RadioGroup aria-label="gender" value={value}>
          <FormControlLabel
            value={'all'}
            onClick={() => handleChange('all')}
            control={
              <Box display="flex" alignItems="center">
                <AppRoundedRadio checked={value === 'all'} color="primary" />
                <Typography color="textSecondary" style={{ marginLeft: 4 }}>
                  Everyone can send messages
                </Typography>
              </Box>
            }
            label=""
          />
          <FormControlLabel
            value={'only_admins'}
            onClick={() => handleChange('only_admins')}
            control={
              <Box display="flex" alignItems="center">
                <AppRoundedRadio checked={value === 'only_admins'} color="primary" />
                <Typography color="textSecondary" style={{ marginLeft: 4 }}>
                  Only group chat admins can send messages
                </Typography>
              </Box>
            }
            label=""
          />
        </RadioGroup>
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>

        <Button
          style={{ width: 130 }}
          disabled={loading}
          onClick={confirmFunction}
          color="primary"
          variant="contained"
        >
          <ButtonTitleWithLoading title="Save changes" loaderVariant="paper" loading={loading} />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
